import Cookies from "js-cookie";
import { ref, watch, type Ref } from "vue";
import type { CookieAttributes } from "js-cookie";

export function useCookie<T>(
    key: string,
    initialValue: T | null = null,
    options: CookieAttributes = {},
): Ref<T | null> {
    const storedValue = Cookies.get(key);
    const cookieValue: Ref<T | null> = ref(
        storedValue !== undefined ? JSON.parse(storedValue) : initialValue,
    );

    watch(
        cookieValue,
        (newValue) => {
            if (newValue === null || newValue === undefined) {
                // Remove cookie with the provided options (including domain)
                Cookies.remove(key, options);

                // Also try to remove without domain in case there's a host-specific cookie
                Cookies.remove(key, { path: options.path || "/" });

                // If domain was specified, also try to remove from current hostname
                if (options.domain) {
                    Cookies.remove(key, {
                        ...options,
                        domain: undefined,
                    });
                }
            } else {
                Cookies.set(key, JSON.stringify(newValue), options);
            }
        },
        { deep: true },
    );

    return cookieValue;
}
